import { Api } from './Api';

export default {
/*  1. Get all data */
    getRoles(keyword = '') {
        return Api().get(`/Role${keyword ? '?Keyword=' + keyword : ''}`);
    },

/*  2. Get one column */
    getRole(id) {
        return Api().get(`/Role/${id}`);
    },

/*  3. Create one column */
    saveRole(body) {
        return Api().post(`/Role`, body);
    },

/*  4. Delete one or more columns */
    deleteRoles(roles) {
        return Api().post(`/Role/DeleteRole`, roles);
    },

/*  5. post one or more columns */
    postRoles(roles) {
        return Api().post(`/Role/PostRole`, roles);
    },
}